import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Routes } from './routes';
import { store } from './store';
import { config } from './utils/config';
import { hotjar } from 'react-hotjar';
import AppLoader from './components/loader/AppLoader';
import LoggerService from './services/api/LoggerService';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { PermissionProvider } from "react-permission-role";
import { IdentityAuthProvider } from './auth';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Inter',
    ].join(','),
  }
});

hotjar.initialize(config.HOTJAR.hjid, config.HOTJAR.hjsv);

function App() {

  useEffect(() => {
    window.onerror = (message, file, line, column, errorObject) => {
      LoggerService.log(message, file, line, column, errorObject);
    };
  }, [])

  return (
    <PermissionProvider>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <IdentityAuthProvider>
              <AppLoader />
              <Routes />
              <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </IdentityAuthProvider>
          </Provider>
        </ThemeProvider>
      </PermissionProvider>
  );
}

export default App;
